module.exports = __webpack_public_path__ + "img/1280.bda4fe64.jpg";